'use strict';
import * as $j_app$002edata$002e$002dOperational$002dApp$002dRegistered$002dUser$0024$002dPharmacy from "./app.data.-Operational-App-Registered-User$-Pharmacy.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_OperationalAppRegisteredUser$Pharmacy$() {
}
export { $c_Lapp_data_OperationalAppRegisteredUser$Pharmacy$ as $c_Lapp_data_OperationalAppRegisteredUser$Pharmacy$ };
$c_Lapp_data_OperationalAppRegisteredUser$Pharmacy$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_OperationalAppRegisteredUser$Pharmacy$.prototype.constructor = $c_Lapp_data_OperationalAppRegisteredUser$Pharmacy$;
/** @constructor */
function $h_Lapp_data_OperationalAppRegisteredUser$Pharmacy$() {
}
export { $h_Lapp_data_OperationalAppRegisteredUser$Pharmacy$ as $h_Lapp_data_OperationalAppRegisteredUser$Pharmacy$ };
$h_Lapp_data_OperationalAppRegisteredUser$Pharmacy$.prototype = $c_Lapp_data_OperationalAppRegisteredUser$Pharmacy$.prototype;
$c_Lapp_data_OperationalAppRegisteredUser$Pharmacy$.prototype.apply__Lapp_data_AppRegisteredUser$PharmacyUser__s_Option = (function(server) {
  if (server.isOperational__Z()) {
    var value = new $j_app$002edata$002e$002dOperational$002dApp$002dRegistered$002dUser$0024$002dPharmacy.$c_Lapp_data_OperationalAppRegisteredUser$Pharmacy(server);
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
  } else {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  }
});
$c_Lapp_data_OperationalAppRegisteredUser$Pharmacy$.prototype.fromProduct__s_Product__Lapp_data_OperationalAppRegisteredUser$Pharmacy = (function(x$0) {
  var server$2 = x$0.productElement__I__O(0);
  return new $j_app$002edata$002e$002dOperational$002dApp$002dRegistered$002dUser$0024$002dPharmacy.$c_Lapp_data_OperationalAppRegisteredUser$Pharmacy(server$2);
});
$c_Lapp_data_OperationalAppRegisteredUser$Pharmacy$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lapp_data_OperationalAppRegisteredUser$Pharmacy(p);
});
var $d_Lapp_data_OperationalAppRegisteredUser$Pharmacy$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_OperationalAppRegisteredUser$Pharmacy$, "app.data.OperationalAppRegisteredUser$Pharmacy$", ({
  Lapp_data_OperationalAppRegisteredUser$Pharmacy$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lapp_data_OperationalAppRegisteredUser$Pharmacy$ as $d_Lapp_data_OperationalAppRegisteredUser$Pharmacy$ };
var $n_Lapp_data_OperationalAppRegisteredUser$Pharmacy$;
function $m_Lapp_data_OperationalAppRegisteredUser$Pharmacy$() {
  if ((!$n_Lapp_data_OperationalAppRegisteredUser$Pharmacy$)) {
    $n_Lapp_data_OperationalAppRegisteredUser$Pharmacy$ = new $c_Lapp_data_OperationalAppRegisteredUser$Pharmacy$();
  }
  return $n_Lapp_data_OperationalAppRegisteredUser$Pharmacy$;
}
export { $m_Lapp_data_OperationalAppRegisteredUser$Pharmacy$ as $m_Lapp_data_OperationalAppRegisteredUser$Pharmacy$ };
//# sourceMappingURL=app.data.-Operational-App-Registered-User$-Pharmacy$.js.map
